import { ProductLine } from '@kouto/types';

export const DEFAULT_MOBILE_GRID = {
  columnGap: 0,
  rowGap: 36,
  templateRows: [{ height: 'minmax(360px, auto)', areas: [0] }],
};

export const DEFAULT_RESULTS_GRID = {
  columnGap: 36,
  rowGap: 96,
  templateRows: [{ height: 'minmax(440px, auto)', areas: [0, 1, 2] }],
};

export const LANDING_PAGE_TITLE_MAP = {
  [ProductLine.HOST]: 'hostProductPageTitle',
  [ProductLine.ACTIVATE]: 'activateProductPageTitle',
  [ProductLine.RESERVE]: 'reserveProductPageTitle',
} as const;
